// idleSlice.js

import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from '@reduxjs/toolkit';
import { logoutUser } from './authLoginSlice';

const idleAdapter = createEntityAdapter();
const session = window.localStorage.getItem('session');
const initialState = session ? Number(session) : Date.now();

const checkIdleTimeout = createAsyncThunk(
  'idle/checkIdleTimeout',
  async (_, { getState, dispatch }) => {
    const { lastActivity } = getState().idle;

    const currentTime = Date.now();
    const idleDuration = currentTime - lastActivity;

    if (idleDuration >= 4 * 60 * 60 * 1000) {
      dispatch(logoutUser());
    }
  }
);

const idleSlice = createSlice({
  name: 'idle',
  initialState: idleAdapter.getInitialState({
    lastActivity: initialState,
  }),
  reducers: {
    updateLastActivity: (state) => {
      state.lastActivity = Date.now();
    },
  },
});

export const { updateLastActivity } = idleSlice.actions;
export default idleSlice.reducer;

export { checkIdleTimeout };
